export enum AutocompletionTypes {
  Geocode = 'geocode',
  Establishment = 'establishment',
}
